import EventEmitter from "eventemitter3";
import { DRYEYEMODES, TOPOGRAPHYMODES } from "../../shared/consts";
import {
  isDefined,
  isFunction,
  isTrue,
  json2string,
  logStdout,
  logTime,
  getSystemTime
} from "../../shared/utils";
import fileSys from "../../fileoprators/fileSystem";
import camera520Mock from "./CameraNode";

import { nibutInfrared } from "../../fileoprators/license";

import "./SerialDevice";
import EVENTS from "../../bus";
import store from "../../store";
import { Message } from "element-ui";
const camera520 = window.__capture__.debug
  ? camera520Mock
  : window.require(fileSys.getUtilPath("Camera520.node"));
let cam;
let _self;
let _IsProcessingData = false;
let motorStatus;
let motorSpeed = 0;
let isSendingMotorCmd = false;
// nibut 相关变量
let nibutAutoStatus = 0;

export const frameBuf = Buffer.alloc(1024 * 768 * 4);

class Capture extends EventEmitter {
  frameCount = 0;
  constructor(only = false) {
    super();
    _self = this;
    setTimeout(() => {
      if (!store.getters.cameraInited) {
        store.dispatch("capture/cameraChangeState", false);
      }
    }, 20 * 1000);
    if (only) return;
    let filePath = fileSys.getTmpFilePath("init.json");
    if (!isDefined(global.cam)) {
      // 这个global变量可以试一下是不是不需要

      let initJson = fileSys.readJsonFile(filePath);

      let reg = isDefined(initJson) && isTrue(initJson.initted);
      // 这个global变量可以试一下是不是不需要
      global.cam = camera520.CameraInit(reg, frameBuf, _self.onFrame);
      cam = global.cam;

      camera520.NIBUTStart(global.cam, window.magecoe.nibut);
      camera520.BLINKStart(global.cam);
      camera520.LipidStart(global.cam);

      initJson = initJson || { initted: true, initcount: 0 };
      initJson.initcount += 1;
      fileSys.saveJsonFile(filePath, initJson);
    } else {
      cam = global.cam;
    }
  }
  setProcessingData(state, from) {
    logStdout("set processing data state", state, from);
    _IsProcessingData = state;
  }
  onFrame(buf, w, h, time) {
    if (window.enable_camera_buf) {
      console.log(buf);
    }
    if (!store.getters.cameraInited) {
      store.dispatch("capture/cameraChangeState", true);
    }
    if (!_IsProcessingData) {
      _self.emit("frame-callback", buf, w, h, time);
    }
  }
  setFrameCallback(framecallback) {
    camera520.CameraSetCallback(framecallback);
  }
  setIsDrawNIBUTAndBUT(isDrawNIBUT, isDrawBUT) {
    let res = camera520.NIBUTSetDisplay(cam, isDrawNIBUT, isDrawBUT);
  }
  eyeTypeRecognise() {
    if (isDefined(global.LiftDevice)) {
      global.LiftDevice.regListen((data) => {
        if (!isDefined(data)) return;
        let eyetype = data.substring(4, 5);
        let shot = data.substring(6, 7);
        _self.emit(EVENTS.eyeTypeShot, eyetype === "1" ? "OD" : "OS", shot === "0");
      });
    }
  }
  setCaptureMode(mode, callback) {
    if (!isDefined(window.camSettings[mode])) return;
    let camcfg, lampcfg;
    if (mode === "blink" && window.captureSettings.isDrawBlink !== 1) {
      camcfg = window.camSettings[`${mode}_nature`].cam;
      lampcfg = window.camSettings[`${mode}_nature`].lamp;
    } else if (mode === "nibut" && !window.captureSettings.SelectLight) {
      camcfg = window.camSettings[`${mode}_infrared`].cam;
      lampcfg = window.camSettings[`${mode}_infrared`].lamp;
    } else if (mode === "tearheight" && !window.captureSettings.TearheightSelectLight) {
      camcfg = window.camSettings[`${mode}_infrared`].cam;
      lampcfg = window.camSettings[`${mode}_infrared`].lamp;
    } else {
      camcfg = window.camSettings[mode].cam;
      lampcfg = window.camSettings[mode].lamp;
    }
    if (!isDefined(window.captureSettings.testMaxValue)) {
      window.captureSettings.testMaxValue = 100;
      saveCaptureSettings(window.captureSettings);
    }

    if (!isDefined(global.LampDevice)) return;

    global.LampDevice.closeLaser((data) => {
      camera520.CameraSetWB(
        cam,
        camcfg.mode,
        camcfg.gamma,
        camcfg.rgain,
        camcfg.ggain,
        camcfg.bgain,
        camcfg.blacklevel
      );

      if (isDefined(global.LampDevice)) {
        console.log(
          "---pupildebug mode--- window.captureSettings.SelectLight",
          window.captureSettings.SelectLight
        );

        if (
          ((mode === "nibut" || mode.includes("pupilcorneadia")) &&
            !window.captureSettings.SelectLight) ||
          (mode === "tearheight" &&
            !window.captureSettings.TearheightSelectLight &&
            window.isNewInfrared())
        ) {
          if (mode === "nibut" || mode === "tearheight") {
            global.LampDevice.closeLamp();
            global.LampDevice.openInfraredLamp(lampcfg.ir * 1.27, (result) => {
              if (isFunction(callback)) {
                callback();
              }
            });
          }
          if (mode.includes("pupilcorneadia")) {
            let curMode = mode === "pupilcorneadia_dynamic";
            if (window.isNewInfrared()) {
              global.LampDevice.openLamp(
                0,
                curMode ? 0 : lampcfg.w,
                0,
                100 - lampcfg.g,
                (result) => {
                  if (isFunction(callback)) {
                    callback();
                  }

                  global.LampDevice.openInfraredLamp(lampcfg.ir * 1.27, (result) => {
                    if (isFunction(callback)) {
                      callback();
                    }
                  });
                }
              );
            } else {
              global.LampDevice.openLamp(
                lampcfg.ir,
                curMode ? 0 : lampcfg.w,
                0,
                100 - lampcfg.g,
                (result) => {
                  if (isFunction(callback)) {
                    callback();
                  }
                }
              );
            }
          }
        } else {
          if (mode.includes("pupilcorneadia")) {
            let curMode = mode === "pupilcorneadia_dynamic";
            if (window.isNewInfrared()) {
              global.LampDevice.openLamp(
                0,
                curMode ? 0 : lampcfg.w,
                0,
                100 - lampcfg.g,
                (result) => {
                  if (isFunction(callback)) {
                    callback();
                  }

                  global.LampDevice.openInfraredLamp(lampcfg.ir * 1.27, (result) => {
                    if (isFunction(callback)) {
                      callback();
                    }
                  });
                }
              );
            } else {
              global.LampDevice.openLamp(
                lampcfg.ir,
                curMode ? 0 : lampcfg.w,
                0,
                100 - lampcfg.g,
                (result) => {
                  if (isFunction(callback)) {
                    callback();
                  }
                }
              );
            }
          } else {
            let curMode = mode === "pupilcorneadia_dynamic";
            global.LampDevice.closeInfraredLamp();
            global.LampDevice.openLamp(
              lampcfg.ir,
              curMode ? window.captureSettings.testMaxValue : lampcfg.w,
              lampcfg.b,
              100 - lampcfg.g,
              (result) => {
                if (isFunction(callback)) {
                  callback();
                }
              }
            );
          }
        }
      }
    });
  }
  openWhiteLamp(mode) {
    if (!isDefined(window.camSettings[mode])) return;
    let lampcfg;
    lampcfg = window.camSettings[mode].lamp;
    if (window.isNewInfrared()) {
      global.LampDevice.openLamp(0, lampcfg.w, 0, 100 - lampcfg.g, (result) => {});
    } else {
      global.LampDevice.openLamp(lampcfg.ir, lampcfg.w, 0, 100 - lampcfg.g, (result) => {});
    }
  }

  closeWhiteLamp(mode) {
    if (!isDefined(window.camSettings[mode])) return;
    let lampcfg;
    lampcfg = window.camSettings[mode].lamp;
    if (window.isNewInfrared()) {
      global.LampDevice.openLamp(0, 0, 0, 100 - lampcfg.g, (result) => {});
    } else {
      global.LampDevice.openLamp(lampcfg.ir, 0, 0, 100 - lampcfg.g, (result) => {});
    }
  }

  setDynamicpupil(mode, lamp) {
    if (!isDefined(window.camSettings[mode])) return;
    let lampcfg;
    lampcfg = window.camSettings[mode].lamp;
    global.LampDevice.openLamp(lampcfg.ir, lamp, lampcfg.b, 100 - lampcfg.g, (result) => {});
  }
  setFilter(mode, callback) {
    if (!isDefined(window.camSettings[mode])) return;
    let f;
    if (mode === "blink" && window.captureSettings.isDrawBlink !== 1) {
      f = window.camSettings[`${mode}_nature`].filter;
    } else if (mode === "nibut" && !window.captureSettings.SelectLight) {
      f = window.camSettings[`${mode}_infrared`].filter;
    } else if (mode === "tearheight" && !window.captureSettings.TearheightSelectLight) {
      f = window.camSettings[`${mode}_infrared`].filter;
    } else {
      f = window.camSettings[mode].filter;
    }

    if (mode.includes("pupilcorneadia") && !nibutInfrared) {
      f = 4;
    }

    if (isDefined(global.LampDevice)) {
      global.LampDevice.setFilter(f, callback);
    }
  }
  closeLaser(callback) {
    global.LampDevice.closeLaser(callback);
  }
  closeAllLamps(callback) {
    global.LampDevice.closeLamp(() => {
      global.LampDevice.closeLaser(callback);
    });
    global.LampDevice.closeInfraredLamp();
  }
  setLaser(nearfar, callback) {
    if (isDefined(global.LampDevice)) {
      if (nearfar === "far") {
        global.LampDevice.openLaserLeft(callback);
      } else if (nearfar === "near") {
        global.LampDevice.openLaserRight(callback);
      }
    }
  }
  setWB(mode) {
    if (!isDefined(cam)) return;
    const { modegray, modergb } = window.camSettings.camCfg;
    switch (mode) {
      case TOPOGRAPHYMODES.pupilcorneadia.key:
      case DRYEYEMODES.meibomian.key:
        camera520.CameraSetWB(
          cam,
          modegray.mode,
          modegray.gamma,
          modegray.rgain,
          modegray.ggain,
          modegray.bgain,
          modegray.blacklevel
        );
        break;
      default:
        camera520.CameraSetWB(
          cam,
          modergb.mode,
          modergb.gamma,
          modergb.rgain,
          modergb.ggain,
          modergb.bgain,
          modergb.blacklevel
        );
        break;
    }
  }
  clearTempFiles(callback) {
    if (fileSys.isLinux()) {
      let dir = fileSys.getMediaPath();
      fileSys.clearAllFiles(dir, [".mp4", ".jpg", ".raw", "*.pdf"], callback);
    } else if (fileSys.isWindow()) {
      let __files = fileSys.readDirectory(fileSys.getMediaPath());
      for (let id in __files) {
        fileSys.deleteFile(__files[id]);
      }
      if (isFunction(callback)) {
        callback();
      }
    }
  }
  wait(filepath, cnt = 0, callback) {
    if (fileSys.isFileExists(filepath)) {
      fileSys.isFileWriteFinished(
        filepath,
        (err) => {
          console.log("isFileWriteFinished--------", err);
          if (!isDefined(err)) {
            console.log("wait 4", err);
            if (isFunction(callback)) callback();
          } else {
            if (isFunction(callback)) callback(err);
          }
        },
        0
      );
    } else {
      if (cnt >= 50) {
        if (isFunction(callback)) callback(new Error("no file"));
      } else {
        setTimeout(() => {
          cnt += 1;
          this.wait(filepath, cnt, callback);
        }, 100);
      }
    }
  }
  takePhoto(filepath, mode = 0) {
    this.stopUpDown();

    return new Promise((resolve, reject) => {
      if (!isDefined(cam)) {
        reject(new Error("cam error"));
      } else {
        camera520.CameraTakePhoto(cam, filepath, mode, (result) => {
          fileSys.sync();
          // _self.wait(filepath, 0, err => {
          //   console.timeEnd('phototake')
          //   fileSys.sync()
          //   if (isDefined(err)) {
          //     reject(err)
          //   } else {
          //     resolve(result)
          //   }
          // })
          resolve(result);
        });
        // camera520.CameraTakePhoto(cam, filepath, mode)
        // _self.wait(filepath, 0, err => {
        //   console.timeEnd('phototake')
        //   fileSys.sync()
        //   if (isDefined(err)) {
        //     reject(err)
        //   } else {
        //     resolve()
        //   }
        // })
      }
    });
  }
  // -----auto nibut functions----
  setAutoNibutParams(FrameDelay, nibutFlag, autoFlag, blinkInv, stageFlag) {
    if (!isDefined(cam)) return null;
    let res = camera520.NIBUTSetParams(cam, FrameDelay, nibutFlag, autoFlag, blinkInv, stageFlag); // autoFlag 0 手动 1自动 nibutFlag 0 fbut 1

    return res;
  }
  // fbut&&nibut shotGet
  getAutoNibutData(mode) {
    let res;
    if (!isDefined(cam)) return null;
    if (mode === "nibut") {
      if (window.captureSettings.SelectLight) {
        res = camera520.NIBUTSHOTGet(cam, 0, 0, 0);
      } else {
        res = camera520.NIBUTIRSHOTGet(cam, 0, 0, 0);
      }
    } else if (mode === "fbut") {
      res = camera520.BUTSHOTGet(cam, 0, 0, 0);
    }

    return res;
  }
  // fbut&&nibut shotClear
  clearAutoNibutData(mode) {
    let res;
    if (!isDefined(cam)) return null;
    if (mode === "nibut") {
      if (window.captureSettings.SelectLight) {
        res = camera520.NIBUTSHOTClear(cam);
      } else {
        res = camera520.NIBUTIRSHOTClear(cam);
      }
    } else if (mode === "fbut") {
      res = camera520.BUTSHOTClear(cam);
    }
  }
  clearAutoNibutTime() {
    if (!isDefined(cam)) return null;
    let res = camera520.NIBUTClear(cam);
  }
  startAutoNibutRecord() {
    if (!isDefined(cam)) return null;
    let res = camera520.SETNibutMode(cam);
  }
  closeAutoNibutRecord() {
    if (!isDefined(cam)) return null;
    let res = camera520.NIBUTSHOTClose(cam);
  }
  // --------------------------------
  takeVideo(filepathMp4, filepathJpg, isNibut, mode, NIBUTModel) {
    this.filepathMp4 = filepathMp4;
    this.filepathJpg = filepathJpg;
    // console.log(
    //   'takeVideo:',
    //   this.filepathMp4,
    //   this.filepathJpg,
    //   window.magecoe.nibut
    // )
    if (isDefined(cam)) {
      if (mode === "nibut") {
        camera520.NIBUTSHOTClear(cam);
        camera520.NIBUTSetParams(cam, 15, 0, NIBUTModel, 1.5, 2); // nibut 参数为0 手动自动需要传参进来改变
      } else if (mode === "fbut") {
        camera520.BUTSHOTClear(cam);
        if (NIBUTModel === 0) {
          camera520.NIBUTSetParams(cam, 15, 1, 0, 1.5, 2);
        } else if (NIBUTModel === 1) {
          camera520.NIBUTSetParams(cam, 15, 1, 1, 1.5, 2);
        }
      } else if (mode === "blink") {
        camera520.BLINKClear(cam);
        camera520.BLINKSetParams(cam, 1);
      } else if (mode === "lipidlayer") {
        camera520.LipidLocClear(cam);
        camera520.LipidSetParams(cam, 1);
      }
    }
    camera520.CameraStartRecord(cam, filepathMp4, filepathJpg, isNibut, window.magecoe.nibut);
  }
  stopVideo(mode, NIBUTModel, recodTime) {
    return new Promise((resolve, reject) => {
      if (!isDefined(cam)) {
        reject(new Error("cam error"));
      } else {
        let Data = {};
        if (mode === "nibut" || mode === "fbut") {
          camera520.NIBUTSetParams(cam, 15, mode === "nibut" ? 0 : 1, NIBUTModel, 1.5, 0);
          Data = camera520.NibutStatistic(cam) || {};
        } else if (mode === "blink") {
          camera520.BLINKSetParams(cam, 0);
          Data = camera520.BLINKStatistics(cam) || {};
        } else if (mode === "lipidlayer") {
          camera520.LipidSetParams(cam, 0);
          Data = camera520.LipidGetReportImg(cam, this.filepathJpg);
        }
        setTimeout(() => {
          camera520.CameraStopRecord(cam, true);
          this.wait(this.filepathMp4, 0, (err) => {
            logTime("stop video");
            fileSys.sync();
            if (isDefined(err)) {
              reject(err);
            } else {
              fileSys.cutVideoByTime(this.filepathMp4, recodTime, (err) => {
                resolve(Data);
              });
            }
          });
        }, 2000);
      }
    });
  }
  nibutStatistic() {
    if (isDefined(cam)) {
      let nibutData = camera520.NibutStatistic(cam);

      if (nibutData) {
        return nibutData;
      } else {
        return {};
      }
    }
  }
  autoCTUpDown(ctCaledOffset) {
    if (isSendingMotorCmd) {
      return;
    }
    let autoMoveCfg = window.ctShotInfo.autoMove;
    let cmd = "stop";
    let speed = 0;
    // 判断电机转动状态
    if (
      autoMoveCfg.updown &&
      isDefined(ctCaledOffset) &&
      isDefined(ctCaledOffset.y) &&
      Math.abs(ctCaledOffset.y) <= autoMoveCfg.range
    ) {
      let offsetY = ctCaledOffset.y;
      if (Math.abs(offsetY) > autoMoveCfg.coarse.range) {
        speed = autoMoveCfg.coarse.speed;
        cmd = offsetY > 0 ? "down" : "up";
      } else if (Math.abs(offsetY) > autoMoveCfg.fine.range) {
        speed = autoMoveCfg.fine.speed;
        cmd = offsetY > 0 ? "down" : "up";
      }
    }
    // 开始转动电机
    if (motorStatus !== cmd || motorSpeed !== speed) {
      let func = global.LiftDevice.stopMachine;
      if (cmd === "down") {
        func = global.LiftDevice.downMachineWithSpeed;
      } else if (cmd === "up") {
        func = global.LiftDevice.upMachineWithSpeed;
      } else {
        isSendingMotorCmd = true;
        global.LiftDevice.stopMachine(() => {
          motorStatus = cmd;
          motorSpeed = speed;
          isSendingMotorCmd = false;
        });
        return;
      }
      isSendingMotorCmd = true;
      func.call(global.LiftDevice, speed, () => {
        motorStatus = cmd;
        motorSpeed = speed;
        isSendingMotorCmd = false;
      });
    }
  }
  stopUpDown(cb) {
    global.LiftDevice.stopMachine(cb);
  }
  closeCamera() {
    if (isDefined(cam)) {
      camera520.BLINKClose(cam);
      camera520.LipidLocClose(cam);
      camera520.CameraClose(cam);
      cam = null;
    }
  }
  startBuleLight() {
    // if (isDefined(cam) && !window.__capture__.debug) {
    //   camera520.BlueLightSetParams(cam, 1)
    // }
  }
  closeBuleLight() {
    // if (isDefined(cam) && !window.__capture__.debug) {
    //   camera520.BlueLightSetParams(cam, 0)
    // }
  }
}
export default Capture;



// WEBPACK FOOTER //
// ./src/mainInterface/js/Capture.js